import { IColumnHeaderProps } from "./IColumnHeaderProps";
import styles from "./ColumnHeader.module.scss";

export const ColumnHeader: React.FC<IColumnHeaderProps> = (props) => {
  return <div className={styles.columnHeader}>{props.caption}</div>;
};
